import { MembershipActivityTypename, Point_Change_Source_Type } from '@occc/graphql';
import { MembershipActivityType, PointChangeTypeFilterValue } from './membership-activity.types';

export const mapPointChangeSourceTypeToLabel: Record<Point_Change_Source_Type, string> = {
  [Point_Change_Source_Type.CommandCenterUser]: 'Command Center User',
  [Point_Change_Source_Type.Expiration]: 'Expiration',
  [Point_Change_Source_Type.GameSession]: 'Game Session',
  [Point_Change_Source_Type.LoyaltyEvent]: 'Loyalty Event',
  [Point_Change_Source_Type.MembershipPointDonation]: 'Donation',
  [Point_Change_Source_Type.OfferPurchase]: 'Offer Purchase',
  [Point_Change_Source_Type.PointChange]: 'Point Change',
  [Point_Change_Source_Type.PromocodeUseRequest]: 'Promocode Use Request',
  [Point_Change_Source_Type.Transaction]: 'Transaction',
  [Point_Change_Source_Type.User]: 'User',
  [Point_Change_Source_Type.StoredValueTransaction]: 'Stored Value Transaction', // TODO: Implement
};

export const membershipActivityFilterOptions: Array<{
  label: string;
  value: MembershipActivityType;
}> = [
  { label: 'Any', value: 'any' },
  { label: 'Point Change Only', value: MembershipActivityTypename.PointChange },
  { label: 'Transactions Only', value: MembershipActivityTypename.Transaction },
];

export const pointChangeTypeFilterOptions: Array<{
  label: string;
  value: PointChangeTypeFilterValue;
  sourceTypes: Point_Change_Source_Type[];
}> = [
  { label: 'Any', value: 'any', sourceTypes: [] },
  {
    label: 'Loyalty Event',
    value: 'loyaltyEvent',
    sourceTypes: [Point_Change_Source_Type.LoyaltyEvent],
  },
  {
    label: 'Offer Fulfillment',
    value: 'offerFulfillment',
    sourceTypes: [Point_Change_Source_Type.Transaction],
  },
  {
    label: 'Reward Redemption',
    value: 'rewardRedemption',
    sourceTypes: [Point_Change_Source_Type.OfferPurchase],
  },
  {
    label: 'Manual Adjustment',
    value: 'manualAdjustment',
    sourceTypes: [Point_Change_Source_Type.CommandCenterUser, Point_Change_Source_Type.User],
  },
  {
    label: 'Donation',
    value: 'donation',
    sourceTypes: [Point_Change_Source_Type.MembershipPointDonation],
  },
  {
    label: 'Promo Code',
    value: 'promoCode',
    sourceTypes: [Point_Change_Source_Type.PromocodeUseRequest],
  },
  {
    label: 'Point Expiration',
    value: 'pointExpiration',
    sourceTypes: [Point_Change_Source_Type.Expiration],
  },
  {
    label: 'Redemption Cancelled',
    value: 'redemptionCancelled',
    sourceTypes: [Point_Change_Source_Type.PointChange],
  },
];
